<template>
  <div class="shop-box">
    <!-- <div class="shuoming">
      <div class="shuoming-item">
        <div class="circle"></div>30天无忧退货
      </div>
      <div class="shuoming-item">
        <div class="circle"></div>48小时快速退款
      </div>
      <div class="shuoming-item">
        <div class="circle"></div>满88元免费邮
      </div>
    </div> -->
    <div class="shop-box-no" v-if="!isLogin">
      <img class="font-cart" src="../../assets/index/shopcar_no.png">
      <!-- <div class="iconfont icon-gouwuche font-cart"></div> -->
      <div class="login-text">您还没有登录</div>
      <div class="login-btn">
        <van-button type="primary" color="#D6BE93" @click="navToLogin" size="large">去登录</van-button>
      </div>

    </div>
    <div class="shop-box-content" v-if="isLogin">
      <div class="shop-box-yes" v-if="$route.path=='/shopCar' ">
        <div v-if="list.cartList.length >0">
          <van-swipe-cell v-for="(cell,index) in list.cartList" :key="index">
            <shopcardcell @getStep="getStepInfo" :cellItem="cell"></shopcardcell>

          </van-swipe-cell>
        </div>
        <div v-else class="shop-no" style="margin: 13rem auto 0">
          <img class="font-cart" src="../../assets/index/shopcar_no.png">
          <!-- <div class="iconfont icon-gouwuche font-cart"></div> -->

          <div class="login-text">购物车是空的</div>
          <div class="login-btn">
            <van-button type="primary" color="#D6BE93" @click="navToIndex" size="large">去购物</van-button>
          </div>
        </div>

        <van-submit-bar v-if="!showEdit" style="margin-bottom:5rem" currency="￥" :price="totleNum" button-text="结算 " @submit="onSubmit">
          <van-checkbox v-model="selectedAll" :disabled="list.cartList.length ==0" @click="isSelect">全选</van-checkbox>
        </van-submit-bar>
        <van-submit-bar v-if="showEdit" style="margin-bottom:5rem;justify-content: space-between;" button-text="删除" @submit="onDeleted">
          <van-checkbox v-model="selectedAll " :disabled="list.cartList.length ==0" @click="isSelect">全选</van-checkbox>
        </van-submit-bar>
        <div class="edit-shopcar" v-if="list.cartList.length >0" @click="setShowEdit">{{showEditText}}</div>

      </div>
      <div class="shop-box-yes" v-else>
        <router-view></router-view>

      </div>
    </div>

  </div>

</template>

<script>
import shopcardcell from "@/components/shopcardcell";
import { cartList, cartChecked, cartDelete } from "@/api/index"; //获取购物车列表
import { Toast, Dialog } from "vant";

export default {
  name: "shopCarBase",
  components: {
    shopcardcell
  },
  data() {
    return {
      isLogin: false,
      selectedAll: false,
      totleNum: 0,
      isCheckedData: {
        productIds: [], //productid.销售id ,全选时传多个销售id,逗号隔开
        isChecked: 0 //是否选中.0:取消 1.选中
      },
      showEdit: false,
      showEditText: "编辑",
      list: {
        cartTotal: {},

        cartList: []
      }
    };
  },
  mounted() {
    this.getCartList();
    console.log(this.$store.state.base.userInfo);
    console.log(sessionStorage.getItem("Token"));
    if (
      this.$store.state.base.userInfo != null &&
      sessionStorage.getItem("Token") != null
    ) {
      this.isLogin = true;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    console.log(to);
    console.log(from);
    console.log(next);
    if (from.path == "/shopCar") {
      from.meta.index = 2;
    }
    next();
  },
  methods: {
    setShowEdit() {
      this.showEdit = !this.showEdit;
      this.showEditText == "编辑"
        ? (this.showEditText = "完成")
        : (this.showEditText = "编辑");
    },
    onDeleted() {
      let data = {
        productIds: []
      };
      this.list.cartList.forEach(element => {
        if (element.checked) {
          data.productIds.push(element.productId);
        }
      });
      if (data.productIds.length == 0) {
        Dialog.alert({
          title: "提示",
          message: "请先选择要删除的商品"
        });
        return;
      }
      Dialog.confirm({
        title: "提示",
        message: "确定删除该商品？"
      })
        .then(() => {
          cartDelete(data).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              this.getCartList();
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getCartList() {
      cartList().then(res => {
        if (res.data.errno == 0) {
          this.list = res.data.data;
          console.log(this.setSelectAll(this.list));

          this.getTotle();
          if (this.setSelectAll(res.data.data)) {
            this.selectedAll = true;
          }
        }
      });
    },
    setSelectAll(list) {
      for (let index = 0; index < list.cartList.length; index++) {
        const element = list.cartList[index];
        console.log(element);
        if (!element.checked) {
          console.log(element);
          return false;
        }
      }
      return true;
    },
    onSubmit() {
      if (this.noChecked()) {
        Toast("您还没有选择宝贝哦");
        return false;
      }
      sessionStorage.removeItem("couponId");

      this.$router.push({
        path: "/order"
      });
    },
    navToIndex() {
      this.$router.push({
        path: "/index"
      });
    },
    noChecked() {
      //未选择商品
      for (const key of this.list.cartList) {
        if (key.checked) {
          return false;
        }
      }
      return true;
    },
    isNoChecked() {
      //是否有未选中的
      for (const key of this.list.cartList) {
        if (!key.checked) {
          return false;
        }
      }
      return true;
    },
    isSelect() {
      if (this.list.cartList.length == 0) return;
      this.isCheckedData.productIds = [];
      this.list.cartList.forEach(element => {
        // element.isChecked = !this.selectedAll;
        this.isCheckedData.productIds.push(element.productId);
        this.isCheckedData.isChecked = !this.selectedAll;
      });
      cartChecked(this.isCheckedData).then(res => {
        if (res.data.errno == 0) {
          this.getCartList();
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    getTotle() {
      this.totleNum = 0;
      this.list.cartList.forEach(element => {
        if (element.checked) {
          this.totleNum += element.number * parseFloat(element.price) * 100;
        }
      });
    },
    getStepInfo(deleted) {
      if (this.isNoChecked()) {
        this.selectedAll = true;
      } else {
        this.selectedAll = false;
      }

      this.getTotle();
      if (deleted == "deleted") {
        this.getCartList();
      }
    },
    navToLogin() {
      this.$router.push("/login");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.shuoming {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 1rem;
  background: #f4f4f4;
  .shuoming-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .circle {
      height: 0.5rem;
      width: 0.5rem;
      border: 1px solid rosybrown;
      border-radius: 100%;
      margin-right: 0.3rem;
    }
  }
}
.shop-box {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  width: 100%;

  // padding-bottom: 11rem;
  box-sizing: border-box;
  background: #fff;
  .shop-box-no {
    height: 100%;
    padding-top: 7rem;
    box-sizing: border-box;

    background: #fff;
    .font-cart {
      width: 80%;
      display: block;
      margin: 0 auto 1rem;
    }
    .login-text {
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: -0.6px;
      text-align: center;
      line-height: 1.9rem;
    }
    .login-btn {
      width: 90%;
      margin: 5rem auto 0;
      border-radius: 33px;
      overflow: hidden;
    }
  }
  .shop-box-content {
    background: #f4f4f4;
    height: 100%;
    box-sizing: border-box;
    .shop-box-yes {
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
      padding-bottom: 10rem;
      background: #fff;

      .shop-no {
        padding-top: 7rem;
        font-size: 1.4rem;
        margin: 0 auto !important;
        .font-cart {
          width: 80%;
          display: block;
          margin: 0 auto 1rem;
        }
        .login-text {
          opacity: 0.5;
          font-family: PingFangSC-Regular;
          font-size: 1.4rem;
          color: #424242;
          letter-spacing: -0.6px;
          text-align: center;
          line-height: 1.9rem;
        }
        .login-btn {
          width: 90%;
          margin: 5rem auto 0;
          border-radius: 33px;
          overflow: hidden;
        }
      }
      .edit-shopcar {
        position: fixed;
        top: 2.1rem;
        right: 1rem;
        z-index: 2;
        font-size: 1.4rem;
        color: #40c6aa;
      }
    }
  }
}
/deep/ .van-submit-bar__bar {
  justify-content: space-between;
}
/deep/ .van-submit-bar__button--danger {
  background: #d6be93;
  border-radius: 24px;
}
</style>




// WEBPACK FOOTER //
// src/view/shopCar/base.vue